import { useAuth } from "../auth/AuthContext";

// Inline SVG so we don't add a dependency. Google's canonical multi-color G.
function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.1 18.9 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 44c5.4 0 10.3-2 14-5.4l-6.4-5.4c-2 1.4-4.6 2.3-7.6 2.3-5.2 0-9.6-3.3-11.2-8l-6.5 5C9.6 39.6 16.2 44 24 44z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.4-2.4 4.4-4.4 5.7l6.4 5.4c-.4.4 6.7-4.9 6.7-15.1 0-1.3-.1-2.3-.4-3.5z"/>
    </svg>
  );
}

export default function GoogleAuthButton({ label = "Continue with Google", testId = "google-auth-btn" }) {
  const { startGoogleLogin } = useAuth();
  return (
    <button
      type="button"
      data-testid={testId}
      className="google-auth-btn"
      onClick={startGoogleLogin}
    >
      <GoogleIcon /> <span>{label}</span>
    </button>
  );
}
